/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiFrontendInternalLinkingNeighborhoodLocaleRetrieve200 } from './model/apiFrontendInternalLinkingNeighborhoodLocaleRetrieve200';

export const apiFrontendInternalLinkingNeighborhoodLocaleRetrieve = (
  countryCode: string,
  language: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingNeighborhoodLocaleRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${language}/${regionSlug}/${citySlug}/${neighborhoodSlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendInternalLinkingNeighborhoodLocaleRetrieveQueryKey = (
  countryCode?: string,
  language?: string,
  regionSlug?: string,
  citySlug?: string,
  neighborhoodSlug?: string
) => {
  return [
    `/api/v7/frontend/internal-linking/${countryCode}/${language}/${regionSlug}/${citySlug}/${neighborhoodSlug}/`,
  ] as const;
};

export const getApiFrontendInternalLinkingNeighborhoodLocaleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodLocaleRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  language: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodLocaleRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingNeighborhoodLocaleRetrieveQueryKey(
      countryCode,
      language,
      regionSlug,
      citySlug,
      neighborhoodSlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodLocaleRetrieve>>
  > = ({ signal }) =>
    apiFrontendInternalLinkingNeighborhoodLocaleRetrieve(
      countryCode,
      language,
      regionSlug,
      citySlug,
      neighborhoodSlug,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryCode && language && regionSlug && citySlug && neighborhoodSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodLocaleRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendInternalLinkingNeighborhoodLocaleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodLocaleRetrieve>>
>;
export type ApiFrontendInternalLinkingNeighborhoodLocaleRetrieveQueryError = ErrorType<unknown>;

export function useApiFrontendInternalLinkingNeighborhoodLocaleRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodLocaleRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  language: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodLocaleRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendInternalLinkingNeighborhoodLocaleRetrieveQueryOptions(
    countryCode,
    language,
    regionSlug,
    citySlug,
    neighborhoodSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
